enum InvoicePaymentType {
  EFA = 'EFA',
  DIG = 'DIG',
}

export default InvoicePaymentType;
